import { createContext, useContext, useMemo } from "react";
import { useFirebaseAuth } from "../hooks/useFirebaseAuth";

// 認証の箱を作る
export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { user, initializing, login, logout } = useFirebaseAuth();

  // useMemoは[...]で与えているものが変わったらreturn内を再レンダリングする
  const value = useMemo( () => {
      return {
        user,
        initializing,
        isLoggedIn: !!user,
        login,
        logout,
      };
    }, [user, initializing, login, logout]
  );

  // 作ったvalueを入れておく
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  // <AuthContext.Providerが持っているvalueを取ってくる
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}